import {
    STATUS_SHIPMENT_DELIVERED, STATUS_SHIPMENT_PARTIALLY_DELIVERED,
    STATUS_SHIPMENT_IN_TRANSIT, STATUS_SHIPMENT_OUT_FOR_DELIVERY,
    STATUS_SHIPMENT_COLLECTED, STATUS_SHIPMENT_TO_BE_SELF_COLLECTED,
    STATUS_SHIPMENT_WITH_INCIDENT, STATUS_SHIPMENT_RETURNED,
    STATUS_SHIPMENT_CANCELED,
} from '../constants/orderStatuses'

export const AGGREGATE_DELIVERED = 'delivered'
export const AGGREGATE_PARTIAL = 'partially_delivered'
export const AGGREGATE_ON_THE_WAY = 'on_the_way'
export const AGGREGATE_PACKED = 'packed'
export const AGGREGATE_RETURNED = 'returned'
export const AGGREGATE_CANCELED = 'canceled'
export const BADGE_PREPARING = 'preparing'

// ORDER-level "on the way" bucket: includes self-collect (pickup-at-location
// is still an in-progress/on-the-way state from the order's point of view).
const ORDER_ON_THE_WAY = [
    STATUS_SHIPMENT_IN_TRANSIT, STATUS_SHIPMENT_OUT_FOR_DELIVERY,
    STATUS_SHIPMENT_COLLECTED, STATUS_SHIPMENT_TO_BE_SELF_COLLECTED,
    STATUS_SHIPMENT_WITH_INCIDENT,
]

// PACKAGE-badge "in transit" bucket: deliberately excludes self-collect, which
// has its own distinct badge/color (yellow) — do not merge these two arrays,
// they intentionally have different membership (see review notes).
const PACKAGE_IN_TRANSIT = [
    STATUS_SHIPMENT_IN_TRANSIT, STATUS_SHIPMENT_OUT_FOR_DELIVERY,
    STATUS_SHIPMENT_COLLECTED,
]

export function deriveOrderAggregateStatus(order) {
    const s = order?.shipping_status
    if (s === STATUS_SHIPMENT_DELIVERED) return AGGREGATE_DELIVERED
    if (s === STATUS_SHIPMENT_PARTIALLY_DELIVERED) return AGGREGATE_PARTIAL
    if (s === STATUS_SHIPMENT_RETURNED) return AGGREGATE_RETURNED
    if (s === STATUS_SHIPMENT_CANCELED) return AGGREGATE_CANCELED
    if (ORDER_ON_THE_WAY.includes(s)) return AGGREGATE_ON_THE_WAY
    return AGGREGATE_PACKED
}

export function derivePackageBadgeStatus(pkg) {
    const s = pkg?.shipping_status
    if (s === STATUS_SHIPMENT_DELIVERED) return STATUS_SHIPMENT_DELIVERED
    if (s === STATUS_SHIPMENT_WITH_INCIDENT) return STATUS_SHIPMENT_WITH_INCIDENT
    if (s === STATUS_SHIPMENT_RETURNED) return STATUS_SHIPMENT_RETURNED
    if (s === STATUS_SHIPMENT_CANCELED) return STATUS_SHIPMENT_CANCELED
    if (s === STATUS_SHIPMENT_TO_BE_SELF_COLLECTED) return STATUS_SHIPMENT_TO_BE_SELF_COLLECTED
    if (PACKAGE_IN_TRANSIT.includes(s)) return STATUS_SHIPMENT_IN_TRANSIT
    return BADGE_PREPARING
}
